module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingStronghold/images/landing-stronghold.bb71667e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingStronghold/images/landing-stronghold.png
// module id = 3148
// module chunks = 11